import { render, staticRenderFns } from "./current-conversation.vue?vue&type=template&id=30486cf9&scoped=true&"
import script from "./current-conversation.vue?vue&type=script&lang=js&"
export * from "./current-conversation.vue?vue&type=script&lang=js&"
import style0 from "./current-conversation.vue?vue&type=style&index=0&id=30486cf9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30486cf9",
  null
  
)

export default component.exports